import React from "react";
import Autocomplete from "react-autocomplete";
import SelectBox from "./SelectBox";

const SearchFormComponent = ({
  filterV,
  setFilterV,
  fieldName,
  onSubmit,
  setCategoryFilter,
  autocompletedSuggestions,
  value,
  onChange,
}) => {
  return (
    <form
      onSubmit={(e) => {
        // onSubmit(e);
        e.preventDefault();
        setCategoryFilter(filterV, value);
      }}
      className="u-form p-search"
    >
      <div className="u-flex">
        <SelectBox {...{ value: filterV, setValue: setFilterV, fieldName }} />
        <div className="u-form-search p-search__input">
          <Autocomplete
            inputProps={{ type: "text" }}
            wrapperStyle={{ display: "block", position: "relative" }}
            menuStyle={{
              borderRadius: "3px",
              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
              background: "rgba(255, 255, 255, 0.9)",
              padding: "2px 0",
              fontSize: "90%",
              position: "absolute",
              overflow: "auto",
              left: "0",
              top: "52",
            }}
            getItemValue={(item) => item.suggestion}
            items={autocompletedSuggestions.documents || []}
            renderItem={(item, isHighlighted) => (
              <div
                key={item.suggestion}
                style={{
                  background: isHighlighted ? "#005eb8" : "white",
                  color: isHighlighted ? "white" : "#005eb8",
                  padding: "1rem",
                  translations: "all 0.5s ease",
                }}
              >
                {item.suggestion}
              </div>
            )}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onSelect={(val) => {
              onChange(val);
              setTimeout(() => {
                setCategoryFilter(filterV, val);
              }, 10);
            }}
          />
          <button type="submit" />
        </div>
      </div>
    </form>
  );
};

export default SearchFormComponent;
